import { homepageViewed, searchButtonClicked } from './main-page';
import { serpPageOpened } from './search-page';
import {
  offerDetailViewed,
  tariffButtonClicked,
  passengerPageOpened,
} from './details-page';
import { hotOffersPageOpened, myTicketsPageOpen } from './hot-offers';
import {
  additionalProductPageOpened,
  bookingButtonClicked,
} from './products-page';
import { paymentPageOpened, payButtonClicked } from './payment-page';

export const jsBridgeEventsLib = {
  homepageViewed,
  searchButtonClicked,
  serpPageOpened,
  offerDetailViewed,
  tariffButtonClicked,
  passengerPageOpened,
  hotOffersPageOpened,
  myTicketsPageOpen,
  additionalProductPageOpened,
  bookingButtonClicked,
  paymentPageOpened,
  payButtonClicked,
};
